import { render, staticRenderFns } from "./imgK.vue?vue&type=template&id=36d45892"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d45892')) {
      api.createRecord('36d45892', component.options)
    } else {
      api.reload('36d45892', component.options)
    }
    module.hot.accept("./imgK.vue?vue&type=template&id=36d45892", function () {
      api.rerender('36d45892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgK.vue"
export default component.exports